__turbopack_context__.v({
  "banner": "login-banner-module-scss-module__1Ir7TW__banner",
  "banner__button": "login-banner-module-scss-module__1Ir7TW__banner__button",
  "banner__buttons": "login-banner-module-scss-module__1Ir7TW__banner__buttons",
  "banner__message": "login-banner-module-scss-module__1Ir7TW__banner__message",
});
